/*
  Produktkachel Neue CI (snippets/flex-produkt-kachel.liquid):
  „In den Warenkorb“ per AJAX hinzufügen und den Warenkorb-Drawer öffnen
  (wie auf der Startseite). Event-Delegation am document, damit es auch nach
  Filter/Sortierung/Paginierung funktioniert (Dawn facets ersetzt das Grid).
  Ohne Drawer oder bei Netzfehler: normales POST auf /cart/add.
*/
(function () {
  if (window.__flexKachel) return;
  window.__flexKachel = true;

  function zeigeFehler(form, text) {
    var el = form.querySelector('.flex-kachel__fehler');
    if (!el) return;
    el.textContent = text || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.';
    el.hidden = false;
  }

  /* Cross-Sell-Rabattcodes (Mitbestell-Preis) am Warenkorb. Der Code gilt
     in Shopify fürs Zubehör allein, deshalb gleicht der Shop ab: liegt der
     Hauptartikel (_xsell_von) nicht mehr im Warenkorb, kommt der Code raus
     (normaler Preis), kommt er zurück, wieder rein. Andere Codes bleiben. */
  function xsCodesImKorb(c) {
    if (Array.isArray(c.discount_codes)) return c.discount_codes.map(function (d) { return d.code; });
    var codes = {};
    function nimm(a) { if (a && a.type === 'discount_code' && a.title) codes[a.title] = true; }
    (c.cart_level_discount_applications || []).forEach(nimm);
    (c.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (d) { nimm(d.discount_application); });
    });
    return Object.keys(codes);
  }
  function xsCodeVon(i) {
    var p = i.properties || {};
    if (!p._xsell_disc) return null;
    return p._xsell_code || ('XS' + p._xsell_disc + '-' + String(i.product_id).slice(-6));
  }
  var xsLetzterAbgleich = null;
  function xsSetzeCodes(codes) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
  }
  window.flexXsCodeDazu = function (code) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var codes = xsCodesImKorb(c);
      if (codes.indexOf(code) === -1) codes.push(code);
      return xsSetzeCodes(codes);
    });
  };
  function xsNeuZeichnen() {
    var drawer = document.querySelector('cart-drawer');
    if (document.querySelector('cart-items')) { window.location.reload(); return; }
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ sections: sections }); }).catch(function () {});
  }
  function xsCodeAbgleich() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var produkte = {};
      (c.items || []).forEach(function (i) { produkte[String(i.product_id)] = true; });
      var noetig = {}, weg = {};
      (c.items || []).forEach(function (i) {
        var code = xsCodeVon(i);
        if (!code) return;
        if (produkte[String(i.properties._xsell_von)]) noetig[code] = true; else weg[code] = true;
      });
      var ist = xsCodesImKorb(c);
      var soll = ist.filter(function (k) { return !weg[k] || noetig[k]; });
      Object.keys(noetig).forEach(function (k) { if (soll.indexOf(k) === -1) soll.push(k); });
      var sig = soll.slice().sort().join(',');
      if (sig === ist.slice().sort().join(',') || sig === xsLetzterAbgleich) return;
      xsLetzterAbgleich = sig; /* nur ein Versuch je Stand, falls Shopify einen Code nicht annimmt */
      return xsSetzeCodes(soll).then(xsNeuZeichnen);
    }).catch(function () {});
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(xsCodeAbgleich, 300); });
  }
  window.addEventListener('load', function () { setTimeout(xsCodeAbgleich, 800); });

  /* Vor dem Entfernen eines Hauptartikels mit rabattiertem Zubehör nachfragen */
  document.addEventListener('click', function (e) {
    var rb = e.target && e.target.closest && e.target.closest('cart-remove-button');
    if (!rb) return;
    if (rb.__xsOk) { rb.__xsOk = false; return; }
    var zeile = rb.closest('tr, .cart-item');
    var marker = zeile && zeile.querySelector('[data-xs-line]');
    var korb = rb.closest('cart-drawer, cart-items, form') || document;
    if (!marker) return;
    var pid = marker.getAttribute('data-pid');
    var gleiche = korb.querySelectorAll('[data-xs-line][data-pid="' + pid + '"]').length;
    if (gleiche > 1) return; /* Hauptartikel liegt noch in einer anderen Zeile */
    var abh = Array.prototype.slice.call(korb.querySelectorAll('[data-xs-line][data-xs-von="' + pid + '"][data-xs-disc]'))
      .filter(function (m) { return m.getAttribute('data-preis') !== m.getAttribute('data-regulaer'); });
    if (!abh.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var seite = !rb.closest('cart-drawer') && zeile.tagName === 'TR';
    var alt = seite ? (zeile.nextElementSibling && zeile.nextElementSibling.classList.contains('flex-xsell-confirm-zeile') ? zeile.nextElementSibling : null) : zeile.querySelector('.flex-xsell-confirm');
    if (alt) { alt.remove(); return; }
    function esc(t) { var d = document.createElement('span'); d.textContent = t; return d.innerHTML; }
    var box = document.createElement('div');
    box.className = 'flex-xsell-confirm';
    box.setAttribute('role', 'alertdialog');
    box.innerHTML = '<p><b>Achtung:</b> Wenn Sie diesen Artikel entfernen, ändert sich der Preis von '
      + abh.map(function (m) {
        return '„' + esc(m.getAttribute('data-titel')) + '“ von ' + esc(m.getAttribute('data-preis')) + ' auf ' + esc(m.getAttribute('data-regulaer'));
      }).join(' und ')
      + '.</p><div class="flex-xsell-confirm__knoepfe"><button type="button" data-xs-ja>Trotzdem entfernen</button><button type="button" data-xs-nein>Behalten</button></div>';
    /* Drawer: unter dem Artikelnamen; /cart: eigene Zeile über die volle Breite (Spalte dort zu schmal) */
    var huelle = box;
    if (seite) {
      huelle = document.createElement('tr');
      huelle.className = 'flex-xsell-confirm-zeile';
      var td = document.createElement('td');
      td.colSpan = zeile.children.length || 4;
      td.appendChild(box);
      huelle.appendChild(td);
      zeile.parentNode.insertBefore(huelle, zeile.nextSibling);
    } else {
      (zeile.querySelector('.cart-item__details') || zeile).appendChild(box);
    }
    box.querySelector('[data-xs-nein]').addEventListener('click', function (ev) { ev.preventDefault(); huelle.remove(); });
    box.querySelector('[data-xs-ja]').addEventListener('click', function (ev) {
      ev.preventDefault();
      huelle.remove();
      rb.__xsOk = true;
      (rb.querySelector('button, a') || rb).click();
    });
  }, true);

  /* Cross-Sell ohne Hauptartikel im Warenkorb (snippets/flex-xsell-hinweis.liquid):
     „Hauptartikel hinzufügen“. Im Drawer neu rendern, auf /cart neu laden. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-flex-xsell-hero]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var drawer = btn.closest('cart-drawer');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = { id: parseInt(btn.getAttribute('data-flex-xsell-hero'), 10), quantity: 1 };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          btn.disabled = false;
          var f = btn.parentNode.querySelector('.flex-xsell-hinweis__fehler');
          if (f) { f.textContent = data.description || data.message || 'Der Artikel konnte nicht hinzugefügt werden.'; f.hidden = false; }
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(data); xsCodeAbgleich(); }
        else window.location.reload(); /* /cart: Abgleich läuft nach dem Laden */
      })
      .catch(function () { window.location.reload(); });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('flex-kachel__form')) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; /* Fallback: normales POST */
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var fehler = form.querySelector('.flex-kachel__fehler');
    if (fehler) fehler.hidden = true;

    function fertig() {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-icon-bubble'); /* beide, sonst wirft renderContents */
    fd.append('sections_url', window.location.pathname);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        fertig();
        if (data && data.status) { /* z. B. nicht mehr verfügbar oder Höchstmenge erreicht */
          zeigeFehler(form, data.description || data.message);
          return;
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      })
      .catch(function () {
        fertig();
        form.submit();
      });
  });
})();
